// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"f86fa53b","806":"f870efce"}[chunkId] + ".chunk.js";
};